/** Messages du serveur (erreurs, notifications, actions proposées, e-mails). */
export default {
  "Accès réservé aux administrateurs.": "Admins only.",
  "L'ID client Google se termine par « .apps.googleusercontent.com ». Vérifiez votre copier-coller.": "The Google client ID ends with “.apps.googleusercontent.com”. Check your copy and paste.",
  "Les identifiants ne doivent pas contenir d'espace : recopiez-les sans espace avant ou après.": "Credentials must not contain spaces: copy them again without leading or trailing spaces.",
  "Utilisateur introuvable.": "User not found.",
  "La date du rappel est déjà passée.": "The reminder date has already passed.",
  "Rappel prévu {0}.": "Reminder scheduled for {0}.",
  "Votre rappel": "Your reminder",
  "Ouvrir mes rappels": "Open my reminders",
  "Rappel : {0}": "Reminder: {0}",
  "Date invalide.": "Invalid date.",
  "Je n'ai pas compris la date. Essayez par exemple : « demain à 10 h ».": "I didn't understand the date. Try for example: “tomorrow at 10 am”.",
  "Tâche introuvable dans cet espace.": "Task not found in this workspace.",
  "en attente d'une tâche dont elle dépend": "waiting for a task it depends on",
  "pause après 90 min de travail": "break after 90 min of work",
  "durée estimée ({0} min) supérieure au plus long créneau libre": "estimated duration ({0} min) longer than the longest free slot",
  "plus de créneau disponible": "no slot left",
  "Tâche introuvable.": "Task not found.",
  "Client introuvable.": "Customer not found.",
  "Créez un espace d'équipe pour inviter des collaborateurs : votre espace personnel reste privé.": "Create a team space to invite colleagues: your personal space stays private.",
  "Cette personne est déjà membre.": "This person is already a member.",
  "La formule de cet espace permet {0} membres (invitations en attente comprises).": "This space's plan allows {0} members (pending invitations included).",
  "Invitation à rejoindre « {0} »": "Invitation to join “{0}”",
  "{0} vous invite à collaborer sur GBC Coach IA (rôle : {1}). L'invitation est valable 7 jours.": "{0} invites you to collaborate on GBC Coach IA (role: {1}). The invitation is valid for 7 days.",
  "{0} vous invite sur GBC Coach IA": "{0} invites you to GBC Coach IA",
  "L'espace doit conserver au moins un propriétaire.": "The space must keep at least one owner.",
  "L'espace personnel ne se partage pas.": "The personal space can't be shared.",
  "Transférez la propriété avant de quitter l'espace.": "Transfer ownership before leaving the space.",
  "{0} a commenté « {1} »": "{0} commented on “{1}”",
  "Invitation invalide ou expirée.": "Invalid or expired invitation.",
  "Cette invitation est destinée à {0}. Connectez-vous avec ce compte.": "This invitation is for {0}. Sign in with that account.",
  "{0} a rejoint l'espace": "{0} joined the space",
  "Base de connaissances": "Knowledge base",
  "Aucun message utilisateur en attente de réponse.": "No user message awaiting a reply.",
  "Conversation vide.": "Empty conversation.",
  "La dernière question a déjà une réponse.": "The last question already has an answer.",
  "La génération a échoué.": "Generation failed.",
  "Avant d'utiliser l'IA, merci d'accepter l'envoi de vos messages au fournisseur d'IA.": "Before using AI, please agree to your messages being sent to the AI provider.",
  "Quota IA quotidien atteint ({0} messages). Il sera réinitialisé à minuit UTC.": "Daily AI quota reached ({0} messages). It resets at midnight UTC.",
  "Date invalide : « {0} ».": "Invalid date: “{0}”.",
  "Projet introuvable dans cet espace.": "Project not found in this workspace.",
  "Le responsable doit être membre de l'espace de travail.": "The assignee must be a member of the workspace.",
  "Dépendance introuvable.": "Dependency not found.",
  "Cette dépendance créerait une boucle.": "This dependency would create a loop.",
  "{0} vous a assigné « {1} »": "{0} assigned you “{1}”",
  "Aucun logo.": "No logo.",
  "Logo invalide : image PNG ou JPEG de 400 Ko maximum.": "Invalid logo: PNG or JPEG image, 400 KB maximum.",
  "La transcription n'est pas encore disponible. Utilisez « Dicter » en attendant.": "Transcription isn't available yet. Use “Dictate” in the meantime.",
  "Fichier audio manquant.": "Missing audio file.",
  "Enregistrement vide.": "Empty recording.",
  "Morceau audio trop volumineux (5 Mo maximum).": "Audio chunk too large (5 MB maximum).",
  "Format audio non pris en charge (webm, ogg, mp3, m4a, wav).": "Unsupported audio format (webm, ogg, mp3, m4a, wav).",
  "Service de transcription injoignable. Réessayez.": "Transcription service unreachable. Try again.",
  "La transcription a échoué. Réessayez dans un instant.": "Transcription failed. Try again in a moment.",
  "10 clés actives maximum : révoquez-en une d'abord.": "10 active keys maximum: revoke one first.",
  "Ce fournisseur d'IA n'est pas disponible.": "This AI provider isn't available.",
  "Profil introuvable.": "Profile not found.",
  "Mon premier plan d'action": "My first action plan",
  "Mémoire introuvable.": "Memory not found.",
  "Créer le client « {0} »": "Create the customer “{0}”",
  "Marquer la facture comme payée{0} et enregistrer l'encaissement": "Mark the invoice as paid{0} and record the payment",
  " le {0}": " on {0}",
  "Ce document n'est pas une facture.": "This document isn't an invoice.",
  "{0} payée ({1})": "{0} paid ({1})",
  "Créer l'objectif « {0} » (cible {1}{2}){3}": "Create the goal “{0}” (target {1}{2}){3}",
  " d'ici le {0}": " by {0}",
  "Activer l'automatisation « {0} »": "Enable the automation “{0}”",
  "{0} (déjà active)": "{0} (already active)",
  "Assigner la tâche au membre choisi (il sera notifié)": "Assign the task to the chosen member (they will be notified)",
  "Ce membre n'appartient pas à l'espace.": "This member doesn't belong to the space.",
  "Publier sur Slack : « {0}{1} »": "Post on Slack: “{0}{1}”",
  "Message publié sur Slack": "Message posted on Slack",
  "Créer le lien Google Meet du rendez-vous (et l'événement dans Google Agenda)": "Create the Google Meet link for the appointment (and the event in Google Calendar)",
  "Lien Google Meet ajouté": "Google Meet link added",
  "Me rappeler « {0} » le {1}{2}": "Remind me “{0}” on {1}{2}",
  " à ": " at ",
  "tous les jours": "every day",
  "jours ouvrés": "weekdays",
  "chaque semaine": "every week",
  "chaque mois": "every month",
  "Date du rappel invalide.": "Invalid reminder date.",
  "Rappel {0} : {1}": "Reminder {0}: {1}",
  "Documents récents": "Recent documents",
  "Automatisations, intégrations et équipe": "Automations, integrations and team",
  "Finances (mois en cours, données saisies)": "Finances (current month, entered data)",
  "Factures émises non payées": "Unpaid issued invoices",
  "Objectifs actifs": "Active goals",
  "{0} facture(s) à relancer": "{0} invoice(s) to chase",
  "{0} — total {1}": "{0} — total {1}",
  "{0} facture(s) arrivent à échéance cette semaine": "{0} invoice(s) due this week",
  "Objectif en retard : {0}": "Goal behind schedule: {0}",
  "{0} % atteint pour {1} % attendu.": "{0}% achieved vs {1}% expected.",
  "Créer la tâche « {0} »{1}{2}": "Create the task “{0}”{1}{2}",
  " — échéance {0}": " — due {0}",
  " — priorité {0}": " — priority {0}",
  "titre « {0} »": "title “{0}”",
  "statut {0}": "status {0}",
  "priorité {0}": "priority {0}",
  "échéance {0}": "due {0}",
  "Modifier une tâche{0}": "Edit a task{0}",
  "Marquer une tâche comme terminée": "Mark a task as done",
  "Réserver le créneau {0} → {1}": "Book the slot {0} → {1}",
  "Bloquer un temps de concentration « {0} » — {1}": "Block focus time “{0}” — {1}",
  "Créer l'événement « {0} » — {1}": "Create the event “{0}” — {1}",
  "Créer le projet « {0} »{1}": "Create the project “{0}”{1}",
  " avec {0} tâche(s)": " with {0} task(s)",
  "Mémoriser : « {0} »": "Remember: “{0}”",
  "Tâches ouvertes (retard, 7 prochains jours, prioritaires)": "Open tasks (overdue, next 7 days, high priority)",
  "Agenda des 7 prochains jours": "Calendar for the next 7 days",
  "Projets actifs": "Active projects",
  "{0} « {1} » de {2} le {3}{4}": "{0} “{1}” of {2} on {3}{4}",
  "prévue": "planned",
  "en attente": "pending",
  "Rappel « {0} » {1}": "Reminder “{0}” {1}",
  "le {0}": "on {0}",
  "Date de rappel invalide.": "Invalid reminder date.",
  "Créer le brouillon « {0} » ({1})": "Create the draft “{0}” ({1})",
  "Préparer le devis « {0} » ({1} ligne(s), {2} € HT) en brouillon": "Prepare the quote “{0}” ({1} line(s), €{2} excl. tax) as a draft",
  "Préparer la facture « {0} » ({1} ligne(s), {2} € HT) en brouillon": "Prepare the invoice “{0}” ({1} line(s), €{2} excl. tax) as a draft",
  "Mettre à jour un objectif : valeur {0}{1}": "Update a goal: value {0}{1}",
  "Objectif introuvable.": "Goal not found.",
  "Cette proposition a déjà été traitée.": "This proposal has already been handled.",
  "Proposition liée à un autre espace de travail.": "Proposal linked to another workspace.",
  "Outil inconnu.": "Unknown tool.",
  "Arguments invalides.": "Invalid arguments.",
  "Action déjà appliquée.": "Action already applied.",
  "Activité courante (moyenne)": "Regular activity (average)",
  "Dépenses courantes (moyenne)": "Running expenses (average)",
  "Achat": "Purchase",
  "Facture {0}": "Invoice {0}",
  "Trésorerie négative prévue": "Negative cash flow expected",
  "Scénario central : solde négatif à partir du {0} (point bas {1}).": "Base case: negative balance from {0} (low point {1}).",
  "Trésorerie sous tension (scénario prudent)": "Cash flow under pressure (cautious case)",
  "En scénario prudent, le solde passerait sous zéro le {0}.": "In the cautious case, the balance would drop below zero on {0}.",
  "Revenus concentrés sur un client": "Revenue concentrated on one customer",
  "{0} représente {1} % de vos recettes sur 90 jours.": "{0} accounts for {1}% of your income over 90 days.",
  "Dépense inhabituelle": "Unusual expense",
  "{0} : {1} (médiane de la catégorie « {2} » : {3}).": "{0}: {1} (median for the “{2}” category: {3}).",
  "Échéance importante à venir": "Large payment coming up",
  "{0} : {1} le {2}.": "{0}: {1} on {2}.",
  "Période invalide.": "Invalid period.",
  "Client ou projet introuvable.": "Customer or project not found.",
  "Suivi — {0}": "Follow-up — {0}",
  "Dossier introuvable.": "Folder not found.",
  "Déplacement impossible : boucle de dossiers.": "Can't move: folder loop.",
  "Aucun fichier reçu.": "No file received.",
  "Fichier trop volumineux (maximum {0} Mo).": "File too large (maximum {0} MB).",
  "Espace de stockage de votre formule atteint.": "Your plan's storage limit has been reached.",
  "{0} tâche(s) en retard": "{0} overdue task(s)",
  "{0} tâche(s) bloquée(s)": "{0} blocked task(s)",
  "Identifiez ce qui les débloque ou demandez de l'aide.": "Find what unblocks them or ask for help.",
  "Semaine surchargée": "Overloaded week",
  "Environ {0} h de travail estimé pour {1} h disponibles.": "About {0} h of estimated work for {1} h available.",
  "Projet « {0} » à risque": "Project “{0}” at risk",
  "Estimez vos tâches": "Estimate your tasks",
  "{0} tâches n'ont pas de durée : le planning sera plus fiable avec une estimation.": "{0} tasks have no duration: planning will be more reliable with an estimate.",
  "Échéance proche : {0}": "Due soon: {0}",
  "À terminer avant {0}.": "To finish before {0}.",
  "Replanifiez-les ou demandez au coach de vous aider à prioriser.": "Reschedule them or ask the coach to help you prioritise.",
  "Facture {0} en retard de paiement": "Invoice {0} is overdue",
  "Préparez une relance avec le Copilote de relance client.": "Prepare a follow-up with the Client Follow-up Copilot.",
  "Facture {0} : échéance le {1}": "Invoice {0}: due on {1}",
  "Votre Weekly Growth Review est prête à être générée": "Your Weekly Growth Review is ready to be generated",
  "Faites le bilan de la semaine{0}.": "Review your week{0}.",
  " et de vos {0} objectif(s) actif(s)": " and your {0} active goal(s)",
  "{0} rappel(s) GBC Coach IA": "{0} GBC Coach IA reminder(s)",
  "Ouvrir mes notifications": "Open my notifications",
  "{0} rappels — GBC Coach IA": "{0} reminders — GBC Coach IA",
  "Paiements non configurés.": "Payments not configured.",
  "Signature invalide.": "Invalid signature.",
  "Traitement impossible.": "Unable to process.",
  "Les paiements ne sont pas configurés sur ce serveur.": "Payments are not configured on this server.",
  "Cette formule n'est pas proposée.": "This plan isn't offered.",
  "Un abonnement est déjà actif : changez de formule depuis l'espace de facturation.": "A subscription is already active: change plans from the billing area.",
  "Aucun compte de facturation pour cet espace.": "No billing account for this space.",
  "Votre ancien abonnement (mode test) a été effacé. Choisissez une formule pour vous abonner.": "Your old (test mode) subscription has been cleared. Choose a plan to subscribe.",
  "Stripe : {0}": "Stripe: {0}",
  "{0} : disponible à partir de la formule {1}.": "{0}: available from the {1} plan.",
  "{0} n'est pas encore activé.": "{0} is not enabled yet.",
  "Connexion {0} refusée : {1}": "{0} connection refused: {1}",
  "Slack n'a pas fourni de canal : choisissez un canal lors de l'autorisation.": "Slack didn't provide a channel: choose one during authorisation.",
  "Aucun jeton reçu.": "No token received.",
  "{0} n'est pas connecté. Connectez-le depuis Intégrations.": "{0} isn't connected. Connect it from Integrations.",
  "La connexion {0} a expiré : reconnectez-la.": "The {0} connection has expired: reconnect it.",
  "Service externe : {0}": "External service: {0}",
  "Google n'a pas pu créer de lien Meet pour ce compte.": "Google couldn't create a Meet link for this account.",
  "Connexion Slack invalide : reconnectez Slack.": "Invalid Slack connection: reconnect Slack.",
  "Slack a refusé le message ({0}). Le canal a peut-être été supprimé : reconnectez Slack.": "Slack rejected the message ({0}). The channel may have been deleted: reconnect Slack.",
  "{0} n'est pas encore activé sur ce serveur (identifiants OAuth manquants).": "{0} isn't enabled on this server yet (missing OAuth credentials).",
  "Ce fichier n'est pas un calendrier iCalendar (.ics).": "This file isn't an iCalendar (.ics) calendar.",
  "Les notifications fonctionnent sur cet appareil.": "Notifications work on this device.",
  "Le plan généré est incomplet. Réessayez ou reformulez l'objectif.": "The generated plan is incomplete. Try again or rephrase the goal.",
  "La fin doit être postérieure au début.": "The end must be after the start.",
  "Intervalle invalide.": "Invalid range.",
  "Intervalle trop large (120 jours maximum).": "Range too wide (120 days maximum).",
  "Dates invalides.": "Invalid dates.",
  "Projet introuvable.": "Project not found.",
  "Facture émise : son contenu n'est plus modifiable. Annulez-la et émettez-en une nouvelle si nécessaire.": "Issued invoice: its content can no longer be edited. Cancel it and issue a new one if needed.",
  "Ce document est déjà finalisé.": "This document is already finalised.",
  "Ajoutez au moins une ligne avant de finaliser.": "Add at least one line before finalising.",
  "Une facture doit être adressée à un client.": "An invoice must be addressed to a customer.",
  "Seul un devis peut être converti en facture.": "Only a quote can be converted into an invoice.",
  "Aucune ligne de prestation.": "No service lines.",
  "Ligne {0} : quantité nulle.": "Line {0}: zero quantity.",
  "Ligne {0} : prix unitaire à 0.": "Line {0}: unit price is 0.",
  "Les totaux enregistrés ne correspondent pas au détail des lignes.": "The saved totals don't match the line details.",
  "Raison sociale de l'émetteur manquante (Paramètres › Entreprise).": "Issuer's company name missing (Settings › Business).",
  "Adresse de l'émetteur manquante.": "Issuer's address missing.",
  "SIRET de l'émetteur manquant.": "Issuer's company number (SIRET) missing.",
  "Numéro de TVA intracommunautaire de l'émetteur manquant.": "Issuer's EU VAT number missing.",
  "Client non renseigné.": "No customer specified.",
  "Adresse du client manquante.": "Customer's address missing.",
  "Date d'échéance manquante.": "Due date missing.",
  "L'échéance est antérieure à la date d'émission.": "The due date is before the issue date.",
  "Mentions de pénalités de retard absentes.": "Late payment penalty notice missing.",
  "Mention « TVA non applicable, art. 293 B du CGI » ajoutée automatiquement.": "Notice “VAT not applicable, art. 293 B of the French Tax Code” added automatically.",
  "Facturation électronique : l'obligation française se déploie progressivement ; un PDF classique ne vaut pas facture électronique conforme. Vérifiez votre calendrier d'obligation.": "E-invoicing: the French requirement is being rolled out gradually; a standard PDF is not a compliant e-invoice. Check your compliance timeline.",
  "La date de validité précède la date du devis.": "The validity date is before the quote date.",
  "Le contenu est très court.": "The content is very short.",
  "{0} champ(s) à compléter : {1}": "{0} field(s) to complete: {1}",
  "Finalisez d'abord le document.": "Finalise the document first.",
  "Règlement facture {0}": "Invoice payment {0}",
  "Une facture émise ne peut pas être supprimée : annulez-la.": "An issued invoice can't be deleted: cancel it.",
  "Type de document inconnu.": "Unknown document type.",
  "Choisissez le document à comparer.": "Choose the document to compare.",
  "Résume ce document en 5 à 10 points clés.": "Summarise this document in 5 to 10 key points.",
  "Lien invalide.": "Invalid link.",
  "Lien expiré ou invalide.": "Expired or invalid link.",
  "Document supprimé.": "Document deleted.",
  "Fichier supprimé.": "File deleted.",
  "Aperçu de votre modèle de document": "Preview of your document template",
  "Message Slack envoyé : {0}": "Slack message sent: {0}",
  "Briefing envoyé sur Slack": "Briefing sent to Slack",
  "Notification : {0}": "Notification: {0}",
  "Tâche créée : {0}": "Task created: {0}",
  "En retard : {0}": "Overdue: {0}",
  "Ouvrez « Focus Recovery » pour proposer de nouveaux créneaux compatibles avec votre agenda.": "Open “Focus Recovery” to propose new slots that fit your calendar.",
  "Replanification proposée": "Rescheduling proposed",
  "Plan de la semaine du {0}": "Plan for the week of {0}",
  "Votre plan de semaine est prêt": "Your weekly plan is ready",
  "Plan de semaine généré": "Weekly plan generated",
  "Bilan de la semaine ({0})": "Weekly review ({0})",
  "Votre bilan de la semaine est prêt": "Your weekly review is ready",
  "Bilan généré": "Review generated",
  "E-mail — {0}": "Email — {0}",
  "Brouillon d'e-mail prêt à relire": "Email draft ready to review",
  "Aucun envoi n'a été effectué.": "Nothing has been sent.",
  "Brouillon d'e-mail préparé (non envoyé)": "Email draft prepared (not sent)",
  "Aucune facture concernée": "No invoice concerned",
  "Relance — facture {0}": "Follow-up — invoice {0}",
  "Relance préparée pour la facture {0}": "Follow-up prepared for invoice {0}",
  "Relisez-la avant de l'envoyer depuis votre messagerie.": "Review it before sending it from your email app.",
  "Relance préparée ({0})": "Follow-up prepared ({0})",
  "Aucun fichier": "No file",
  "Aucun classement évident": "No obvious folder",
  "Classer « {0} » dans « {1} » ?": "File “{0}” in “{1}”?",
  "Le dossier existe déjà : déplacez le fichier depuis Fichiers.": "The folder already exists: move the file from Files.",
  "Créez un dossier « {0} » pour regrouper ce type de fichiers.": "Create a “{0}” folder to group this type of file.",
  "Classement proposé : {0}": "Suggested folder: {0}",
  "Aucun projet": "No project",
  "{0} tâche(s) proposée(s) pour « {1} »": "{0} task(s) proposed for “{1}”",
  "Validez celles que vous souhaitez créer.": "Approve the ones you want to create.",
  "{0} tâche(s) proposée(s), en attente de validation": "{0} task(s) proposed, awaiting approval",
  "Objectif introuvable": "Goal not found",
  "Plan correctif — {0}": "Recovery plan — {0}",
  "Plan correctif proposé : {0}": "Recovery plan proposed: {0}",
  "Plan correctif proposé": "Recovery plan proposed",
  "Modèle inconnu.": "Unknown template.",
  "Limite quotidienne atteinte ou automatisation inactive.": "Daily limit reached or automation inactive.",
  "Conditions non remplies": "Conditions not met",
  "Tâche proposée, en attente de validation": "Task proposed, awaiting approval",
  "Échec de l'automatisation « {0} »": "Automation “{0}” failed",
  "Le Coach IA est momentanément indisponible. Réessayez dans quelques minutes.": "The AI Coach is temporarily unavailable. Try again in a few minutes.",
  "Réponse de l'IA inexploitable (JSON attendu).": "Unusable AI answer (JSON expected).",
  "Réponse de l'IA inexploitable (JSON invalide).": "Unusable AI answer (invalid JSON).",
  "Réinitialisation de votre mot de passe": "Reset your password",
  "Bonjour {0}, vous avez demandé à réinitialiser votre mot de passe. Ce lien est valable une heure.": "Hello {0}, you asked to reset your password. This link is valid for one hour.",
  "Choisir un nouveau mot de passe": "Choose a new password",
  "Réinitialisez votre mot de passe": "Reset your password",
  "Confirmez votre adresse e-mail": "Confirm your email address",
  "Bienvenue {0} ! Confirmez votre adresse pour sécuriser votre compte GBC Coach IA.": "Welcome {0}! Confirm your address to secure your GBC Coach IA account.",
  "Confirmer mon adresse": "Confirm my address",
  "Si vous n'êtes pas à l'origine de cette demande, ignorez cet e-mail.": "If you didn't make this request, ignore this email.",
  "Accès refusé.": "Access denied.",
  "Route API inconnue.": "Unknown API route.",
  "Droits insuffisants pour cette action.": "Insufficient rights for this action.",
  "Accès en lecture seule sur cet espace de travail.": "Read-only access to this workspace.",
  "Clé d'API invalide ou révoquée.": "Invalid or revoked API key.",
  "Cette route n'est pas accessible avec une clé d'API.": "This route isn't available with an API key.",
  "Cette clé d'API est en lecture seule.": "This API key is read-only.",
  "L'API est incluse dans la formule Pro.": "The API is included in the Pro plan.",
  "Trop de requêtes : 120 par minute maximum.": "Too many requests: 120 per minute maximum.",
  "Authentification requise.": "Authentication required.",
  "Vous n'êtes pas membre de cet espace de travail.": "You are not a member of this workspace.",
  "Espace de travail introuvable pour ce compte.": "Workspace not found for this account.",
  "Ce module est temporairement désactivé.": "This module is temporarily disabled.",
  "Données invalides.": "Invalid data.",
  "Une erreur interne est survenue.": "An internal error occurred.",
} as Record<string, string>;
